<template>
  <div class="login">
    <div class="loginForm">
      <div class="login_text">INTERVIEW 2.0</div>
      <div class="wrap id_wrap">
        <span class="input_label"><v-icon>person</v-icon></span>
        <input class="input id" id="inputId" v-focus type="text" v-model.trim="id"
          @keyup.enter="login" name="username" placeholder="사용자 ID" autocomplete="username">
      </div>
      <div class="wrap pw_wrap">
        <span class="input_label"><v-icon>vpn_key</v-icon></span>
        <input class="input pw" id="input_pw" type="password" v-model.trim="pwd"
          @keyup.enter="login" placeholder="비밀번호">
      </div>
      <button class="login_btn" @click="login">login</button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState, mapMutations } from 'vuex'

  export default {
    name: 'login',
    data () {
      return {
        id: '',
        pwd: ''
      }
    },
    methods: {
      ...mapActions([
        'getCampaginList',
        'getDashboardData',
        'loginRequset'
      ]),
      ...mapMutations([
        'setLoginStatus'
      ]),
      login () {
        let id = document.getElementById('inputId')
        let pw = document.getElementById('inputId')
        if (!this.id) {
          alert('사용자ID를 입력하세요.')
          id.focus()
          return
        }
        if (!this.pwd) {
          alert('비밀번호를 입력하세요.')
          pw.focus()
          return
        }
        if (this.id.match(/[^a-zA-Z0-9\\@]/) != null) {
          alert('사용자ID는 영문,숫자,@ 만 입력가능합니다.')
          id.focus()
          return
        }
        if (this.pwd.match(/[^a-zA-Z0-9\\@]/) != null) {
          alert('비밀번호는 영문,숫자,@ 만 입력가능합니다.')
          id.focus()
          return
        }

        let epw = ''
        for (let i = 0; i < this.pwd.length; i++) {
          let temp = this.pwd[i].charCodeAt(0) + 1
          epw += String.fromCharCode(temp)
        }
        epw = btoa(epw)
        this.loginRequset({id: this.id, pwd: epw})
      }
    },
    computed: {
      ...mapState([
        'loginStatus'
      ])
    },
    watch: {
      loginStatus (val) { // store의 로그인 정보 변경 감시 -> 로그인 ajax요청 후 response 받아 0/-1로 수정되면 실행
        if (val === 0) { // 정상 로그인 - 0
          this.getDashboardData()
          this.getCampaginList()
          this.$router.push('/main')
        } else if (val === -1) { // 로그인 실패 - -1
          alert('사용자 정보를 확인하시고, 다시 로그인 해주세요.')
          this.pwd = ''
          document.getElementById('input_pw').focus()
          this.setLoginStatus(999) // 로그인 상태 확인위해서 0/-1 이 아닌값으로 변경
        }
      }
    },
    created () {
      if (sessionStorage.getItem('iw_u') !== null) { // 로그인된 상태로 진입시 main으로 보냄
        this.$router.push('/main')
      }
    }
  }
</script>

<style scoped>
  .login {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0;
    padding: 0;
    border: none;
    overflow: hidden;
  }
  .loginForm {
    margin-top: -85px;
    position: relative;
    width: 300px;
    background: #fff;
    border-radius: 7px;
    text-align: center;
    border: 1px solid #d1dce3;
    margin-bottom: 25px;
  }

  .login_text {
    height: 30px;
    line-height: 30px;
    font-size: 20px;
    padding-top: 13px;
    padding-bottom: 13px;
    color: #fff;
    font-weight: 600;
    background-color: #444;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }

  .wrap {
    margin-left: auto;
    margin-right: auto;
    width: 90%;
    position: relative;
    display: table;
    border-collapse: separate;
    margin-top: 20px;
  }
 .input_label {
    height: 44px;
    min-width: 50px;
    line-height: 42px;
    border: 2px solid #d2d2d2;
    border-right: 0;
    font-size: 14px;
    font-weight: 400;
    color: #8f8f8f;
    text-align: center;
    width: 1%;
    white-space: nowrap;
    vertical-align: middle;
    box-sizing: border-box;
    border-collapse: separate;
  }
  .input_label i {
    vertical-align: middle;
  }
  .input {
      border: 2px solid #d2d2d2;
      width: calc(100% - 14px);
      padding-left: 10px;
      border-radius: 0;
      -webkit-appearance: none; /* ios input border-radius, box-show 제거 */
  }
  .input_label, .input {
      display: table-cell;
      height: 40px;
  }

  .login_btn {
    width: 90%;
    margin: 20px 0;
    height: 35px;
    border: none;
    background: linear-gradient(to bottom,#5cb85c 0,#419641 100%);
    border: 1px solid #419641;
    color: #fff;
    font-weight: bold;
  }
  .login_btn:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?5e165329